module.exports = __webpack_public_path__ + "static/media/pts4.1897f696.jpg";